import ScheduleIcon from '@material-ui/icons/Schedule';
import { getMinutesInHourAndMinutesStr } from '../../../util';
import { withStyles } from '@material-ui/core';
import CustomTooltip from './CustomTooltip';

const styles = {
  violation: {
    color: '#FA5C64'
  },
  noViolation: {
    color: '#05A792'
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  scheduleIcon: {
    fontSize: 16,
    marginRight: 2
  }
};

const StopTime = ({ actualStopTime, plannedStopTime, classes }) => {
  return (
    <div className={classes.container}>
      <CustomTooltip title="Actual Stop Time">
        <div className={actualStopTime > plannedStopTime ? classes.violation : classes.noViolation}>
          {getMinutesInHourAndMinutesStr(actualStopTime, true)}
        </div>
      </CustomTooltip>
      {' | '}
      <CustomTooltip title="Estimated Stop Time">
        <div className={classes.container}>
          <ScheduleIcon className={classes.scheduleIcon} />
          {getMinutesInHourAndMinutesStr(plannedStopTime, true)}
        </div>
      </CustomTooltip>
    </div>
  );
};

export default withStyles(styles)(StopTime);
